@if (viewState.showSecondFactor && res) {
  <abc-two-step-auth
    [confirmationcodeFilled]="confirmationcodeFilled"
    [confirmSecondFactor]="confirmSecondFactor"
    [cancelSecondFactor]="cancelSecondFactor"
    [setOptionalSecondFactor]="setOptionalSecondFactor"
    [onClick]="onClick"
    [onPaste]="onPaste"
    [onInput]="onInput"
    [onKeydown]="onKeydown"
    [Form]="Form"
    [viewState]="viewState"
    [username]="username.value"
    [baseUrl]="baseUrl"
    [secret]="secret()"
    [issuer]="issuer"
    [placeholders]="placeholders"
    [inputMode]="inputMode"
    [inputType]="inputType"
    [res]="res"
  ></abc-two-step-auth>
}

<!-- Login Form -->
@if (!viewState.showSecondFactor && !showLoader && (resAsync | async) && templateIcons()) {
  <form
    [dir]="rtlEnabled ? 'rtl' : 'auto'"
    id="form"
    class="login-form {{ errorClass ? ' ' + errorClass : '' }}"
    [formGroup]="Form"
    method="POST"
    (ngSubmit)="onSubmit()"
  >
    @if(viewState.showLogin) {
      <!-- Username Field -->
      <abc-text-box
        #userNameInput
        [height]="'60px'"
        [width]="'100%'"
        [label]="res.get('Login-Username')"
        [name]="'username'"
        [mode]="'text'"
        [stylingMode]="'filled'"
        [formControlName]="'username'"
        [valueChangeEvent]="'input'"
        (click)="onInputClick()"
        (onKeyUp)="clearLastValidation()"
      >
        <dxi-button
          name="clear-username"
          [options]="{
            icon: templateIcons().get('clearIcon'),
            visible: hasUserName || userNameAutoFilled(),
            onClick: clearUserName,
        tabIndex: -1
          }"
        ></dxi-button>
      </abc-text-box>
      <!-- Password Field -->
      <abc-text-box
        #passwordInput
        [height]="'60px'"
        [width]="'100%'"
        [label]="res.get('Login-Password')"
        [name]="'password'"
        [mode]="pw_vis ? 'text' : 'password'"
        [stylingMode]="'filled'"
        [formControlName]="'password'"
        [valueChangeEvent]="'input'"
        (click)="onInputClick()"
        (beforeinput)="onPasswordBeforeInput()"
        (onKeyUp)="clearLastValidation()"
      >
        <dxi-button
          name="toggle-password"
          [options]="{
            icon: pw_vis ? templateIcons().get('passwordShowIcon') : templateIcons().get('passwordHideIcon'),
            visible: isPasswordChanged && hasPassword,
            onClick: togglePasswordVisibility,
        tabIndex: -1
          }"
        ></dxi-button>
        <dxi-button
          name="clear-password"
          [options]="{
            icon: templateIcons().get('clearIcon'),
            visible: hasPassword || passwordAutofilled(),
            onClick: clearPassword,
        tabIndex: -1
          }"
        ></dxi-button>
      </abc-text-box>
      <div class="buttons">
        <button mat-raised-button id="LoginButton" class="loginBtn" name="submit">
          {{ res.get('Login-Login') }}
        </button>
        <button mat-raised-button class="cancelBtn" type="button" (click)="back()">
          {{ res.get('Login-Cancel') }}
        </button>
      </div>
      } @if(ErrorMessage()?.length) {
      <div class="errorStyleClass {{ errorClass ? ' ' + errorClass : '' }}">
        <!-- Errors -->
        <div class="warning">
          <abc-icon [svgIcon]="res.svgUrl('Warning-Image')"></abc-icon>
          @if(ErrorMessage() !== 'refresh_token' && ErrorMessage() !== 'invalid_session'){
            <div class="msgError">
              {{ res.get('Login-Error') }}
            </div>
          }
        </div>
        <!-- Session change section -->
        @if(viewState.showTakeoverSession){
          <div class="descriptionError">
            <span>{{ res.get('Login-InvalidSession') }}</span>
            <abc-select-box
              [dataSource]="sessions"
              [placeholder]="res.get('Login-SelectSession')"
              [displayExpr]="'user_name'"
              [(ngModel)]="clientIdToReplace"
              [valueExpr]="'client_id_toreplace'"
              [acceptCustomValue]="false"
              [showClearButton]="false"
              [ngModelOptions]="{ standalone: true }"
            ></abc-select-box>
            <div class="buttons">
              <button
                [disabled]="!clientIdToReplace"
                mat-raised-button
                id="LoginButton"
                class="loginBtn"
                name="submit"
                (click)="onSessionSelected(clientIdToReplace)"
                type="button"
              >
                {{ res.get('Login-UseSession') }}
              </button>
              <button type="button" mat-button class="cancelBtn" mat-stroked-button (click)="back()" type="button">
                {{ res.get('Login-Cancel') }}
              </button>
            </div>
          </div>
        }
        <!-- Errors -->
        @if (ErrorMessage() !== 'refresh_token' && ErrorMessage() !== 'invalid_session') {
          <div class="descriptionError">
            @switch (ErrorMessage()) { @case ('missing_credentials') {
                <span [innerHTML]="res.get('Login-DefaultErrorCredentials')"> </span>
              } @case ('missing_username') {
                <span [innerHTML]="res.get('Login-DefaultErrorUserName')"> </span>
              } @case ('missing_password') {
                <span [innerHTML]="res.get('Login-DefaultErrorPassword')"> </span>
              } @default {
                <span>
                  {{ res.get('Login-ErrorDescriptionMessage-1') }} <br />
                  {{ res.get('Login-ErrorDescriptionMessage-2') }}
                </span>
              } }
          </div>
            } @if(ErrorMessage() === 'refresh_token'){
          <div class="descriptionError">
            <span> {{ res.get('Login-ErrorRefreshToken') }}</span>
          </div>
            } @if(ErrorMessage() !== 'invalid_session'){
          <div class="lockoutInfo">
              @if(loginLockoutWarning){
              <div class="descriptionError">
                <span> {{ res.get('Login-Lockout-Warning') }} {{ lockoutRetries }}</span>
              </div>
                } @if(loginLockout){
              <div class="descriptionError">
                <span>{{ res.get('Login-Lockout-Time', lockoutSeconds.toString()) }}</span>
              </div>
                } @if(loginLockout){
              <div class="descriptionError">
                <span> {{ res.get('Login-Lockout-Time-2', lockoutEndString) }}</span>
              </div>
            }
          </div>
        }
      </div>
    }
    <br />
    <!-- Password change + Registration + WebApi change -->
      @if( showResetPassword) {
      <div class="link-container forgot-password">
        <a (click)="onForgotPassword()">{{ res.get('Login-Password-Forgotten') }}</a>
      </div>
        } @if(showRegistration){
      <div class="link-container">
        <p>{{ res.get('Login-Register-Question') }}</p>
        &nbsp;&nbsp;
        <a [routerLink]="['/', 'registration']">{{ res.get('Login-Register') }}</a>
      </div>
        } @if(isChangingWebApiSupported && isAllowBaseURLChange && !specialLogin && viewState.showLogin) {
      <div class="link-container">
        <a (click)="editWebAPI()">{{ res.get('Login-EditWebApi') }}</a>
      </div>
    }
  </form>
}

<!-- Loader section -->
  @if(showLoader && viewState.showLogin && (resAsync | async)) {
  <div class="loaderClass {{ errorClass ? ' ' + errorClass : '' }}">
      @if(useCustomLoader){
      <ng-content select="[custom-loader]"></ng-content>
        }@else {<dx-load-indicator [visible]="true" style="margin: 20px 0px"></dx-load-indicator>}
  </div>
}
